import React, { useState, useEffect } from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CButton,
  CFormCheck,
  CFormInput, CInputGroup, CInputGroupText
} from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData, useLocation } from 'react-router-dom';
import axios from "axios";
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import AxiosInstance from 'src/components/Axios';
import { confirmAlert } from 'react-confirm-alert';
import CIcon from '@coreui/icons-react';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import { formatShortName, formatUTC } from 'src/store';
import Status from 'src/components/tableElements/Status';
import CustomPagination from 'src/components/pagination/CustomPaginatiion';
import FilterDropdownBlog_main from 'src/components/news/FilterDropdownBlog_main';
import dayjs from 'dayjs'
import ActiveFilters from 'src/components/ActiveFilters';


const page = 1;
const postPerPage = 0;
const pageSize = 20;
const user = localStorage.getItem('user_data');

export async function LoaderBlog({ params }) {
  // console.log('params', params)
  let prm = { page: 1 };
  let prm2 = { pagination: false }
  if (params.type != undefined) {
    prm['type'] = params.type;
    prm2['type'] = params.type;
  }

  let res = await AxiosInstance.get('/posts', {
    params: {
      ...prm,
      ...(!Permissions(user, 'Blog', 'SHOW_BLOG') && { show: true })
    }
  }).then((response) => {
    response['type'] = (params.type != undefined) ? params.type : "page";
    // console.log(response)
    return response;
  });
  if (res.type == undefined)
    res['type'] = (params.type != undefined) ? params.type : "page";

  // Фільтрація на клієнтській стороні - тільки ua або null мова
  res.data['hydra:member'] = res.data['hydra:member'].filter(page =>
    page.language === null || page.language.id === 1
  );

  //додатковий запит за всими постами по типу без пагінаціі,щоб потім потягнути звідти усих авторів


  let res2 = await AxiosInstance.get('/posts', {
    params: {
      ...prm2,
      // ...(!Permissions(user, 'Blog', 'SHOW_BLOG') && { show: true })
    }
  }).then((response) => {
    response['type'] = (params.type != undefined) ? params.type : "page";
    // console.log('res2', response)
    return response;
  });
  if (res2.type == undefined)
    res2['type'] = (params.type != undefined) ? params.type : "page";

  // Фільтрація на клієнтській стороні - тільки ua або null мова
  res2.data['hydra:member'] = res2.data['hydra:member'].filter(page =>
    page.language === null || page.language.id === 1
  );

  //додатковий запит за всими постами по типу без пагінаціі,щоб потім потягнути звідти усих авторів(верх)

  // return res;
  return {
    data: res.data,
    allPosts: res2.data,
    type: res.type
  }
}


const rows = [];

const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };

const Blog = () => {
  if (!Permissions(user, 'Blog', 'VIEW_BLOG')) {
    return <PermissionsNoPage />;
  }

  // const { data, type } = useLoaderData();
  const { data, type, allPosts } = useLoaderData()
  // console.log('data', data)
  // console.log('allPosts', allPosts)
  const [rows, setRows] = useState(
    data['hydra:member']
  );
  const [rowCount, setRowCount] = useState(data['hydra:totalItems'] || 0);
  const [pageSize, setPageSize] = useState(20);

  const postPerPage = page * data['hydra:totalItems'];
  const location = useLocation();

  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);

  //актуальна сторінка
  const [currentPage, setCurrentPage] = useState(1);

  //СТАНИ ДЛЯ ФІЛЬТРА

  //стан для всих постів без пагінаціі
  const [posts, setPosts] = useState(allPosts['hydra:member'] || [])
  //стан для списку субайтемів
  const [selectedSubItems, setSelectedSubItems] = useState([]);

  //стан  видимості по фільтру(фільтр)
  const [visibilityFilter, setVisibilityFilter] = useState(undefined)

  //стан для всих авторів
  const [allOwners, setAllOwners] = useState(
    findAllOwners(allPosts).flatOwners ||
    [])

  //стан для дати date_from
  const [dateFrom, setDateFrom] = useState(null)


  //стан для дати date_to
  const [dateTo, setDateTo] = useState(null)

  //
  const [makeRequest, setMakeRequest] = useState(false)

  // стан для компонента активних фільтрів
  const [activeFilters, setActiveFilters] = useState([])

  // const getRowsTable = (p = 1) => {
  //   let prm = { page: p };
  //   if (type != 'post')
  //     prm['type'] = type;

  //   AxiosInstance.get('/posts', { params: prm }).then((response) => {
  //     // Фільтрація на клієнтській стороні для обробки null
  //     const filteredRows = response.data['hydra:member'].filter(page =>
  //       page.language === null || page.language.id === 1
  //     );
  //     setRows(filteredRows);

  //   });
  // };


  //параметри атрибутів для фільтра
  const buildFilterParams = () => ({
    'show': visibilityFilter === 'visible' ? true : visibilityFilter === 'non_visible' ? false : null,
    // 'id': projectsId,
    'owners.id': selectedSubItems.find(elem => elem.slug === 'Owners') ? selectedSubItems.find(elem => elem.slug === 'Owners').id : null,
    // 'status': projectsStatus ? projectsStatus : null
    'id': selectedSubItems.find(elem => elem.slug === 'Posts') ? selectedSubItems.find(elem => elem.slug === 'Posts').id : null,
    'dateEntered[after]': dateFrom ? dayjs(dateFrom)
      // .tz('Europe/Kyiv')
      .format('YYYY-MM-DDTHH:mm:ssZ') : null,
    'dateEntered[before]': dateTo ? dayjs(dateTo)
      // .tz('Europe/Kyiv')
      .format('YYYY-MM-DDTHH:mm:ssZ') : null

  });

  const getRowsTable = (p = 1) => {
    const filterParams = buildFilterParams()
    let prm = { page: p, itemsPerPage: pageSize, ...filterParams };
    if (type !== 'post')
      prm['type'] = type;

    AxiosInstance.get('/posts', { params: prm }).then((response) => {
      const filteredRows = response.data['hydra:member'].filter(page =>
        page.language === null || page.language.id === 1
      );
      setRows(filteredRows);
      setRowCount(response.data['hydra:totalItems']);
    });
  };

  //функція для отримання всих постів з pagination false для фільтра

  function getAllPostsWithoutPagination() {
    //  const filterParams = buildFilterParams()
    let prm = {
      pagination: false
    };
    if (type !== 'post')
      prm['type'] = type;

    AxiosInstance.get('/posts', { params: prm }).then((response) => {
      const filteredRows = response.data['hydra:member'].filter(page =>
        page.language === null || page.language.id === 1
      );
      // console.log('response', filteredRows)
      // console.log('filteredRows', filteredRows)
      // console.log('response.data', response.data)
      setPosts(filteredRows)
      setAllOwners(findAllOwners(response.data).flatOwners)
      // setRows(filteredRows);
      // setRowCount(response.data['hydra:totalItems']);


    });
  }


  useEffect(() => {
    if (dateFrom && dateTo) {
      // console.log('request')
      getRowsTable(currentPage)
    } else if (dateFrom === null && dateTo === null && makeRequest === true) {
      getRowsTable(currentPage)
    }
  }, [dateFrom, dateTo, makeRequest])

  useEffect(() => {
    getRowsTable(currentPage);
  }, [location, visibilityFilter, selectedSubItems]);

  // useEffect(() => {
  //   getAllPostsWithoutPagination()
  // }, [])

  const handlePageChange = (page) => {

    //
    setCurrentPage(page + 1)
    //
    getRowsTable(page + 1);
  };

  // function handleSearch(event) {
  //   axios.get(process.env.REACT_APP_SERVER_URL + '/api/objects?name=' + event.target.value, header).then((response) => {
  //     setRows(response.data['hydra:member']);
  //   });
  // }
  function handleSearch(event) {
    const searchValue = event.target.value;
    let prm = { name: searchValue, page: 1 };

    if (type !== 'post') {
      prm['type'] = type;
    }

    AxiosInstance.get('/posts', {
      params: prm,
      headers: {
        Authorization: `Bearer ${tokenStr}`
      }
    }).then((response) => {
      const filteredRows = response.data['hydra:member'].filter(page =>
        page.language === null || page.language.id === 1
      );
      setRows(filteredRows);
    }).catch(error => {
      console.error('Search request failed:', error);
    });
  }


  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };


  //функція для додавання активних фільтрів в стан
  function handleActiveFilters(filterSlug, filterLabel, optionSlug, optionLabel, optionId, optionFirstName, optionLastName) {
    setActiveFilters(prev => {
      const filtered = prev.filter(item => item.filterSlug !== filterSlug);
      return [...filtered, { filterSlug, filterLabel, optionSlug, optionLabel, optionId, optionFirstName, optionLastName }];
    })
  }


  //функція для додавання пункту субменю випадайки в стан

  function handleSubItem(id, slug) {
    // console.log(id, 'id', slug, 'slug')
    setSelectedSubItems(prev => {
      const filtered = prev.filter(item => item.slug !== slug);
      return [...filtered, { slug, id }];
    });
  }

  //функція для очистки selectedSubItems
  function cleanListItem(slug) {
    setActiveFilters(
      activeFilters.filter(elem => elem.filterSlug !== slug)
    )
    if ((slug === 'Visibility' && visibilityFilter === 'visible') || (slug === 'Visibility' && visibilityFilter === 'non_visible')) {
      // console.log('not set')
      setVisibilityFilter(undefined)
      return
    }

    // else if (slug === 'Projects') {
    //   setProjectsId(null)
    //   setSelectedSubItems(selectedSubItems => selectedSubItems.filter(elem => elem?.slug !== slug))
    //   return
    // }

    // else if (slug === 'Status') {
    //   setProjectsStatus('')
    //   setSelectedSubItems(selectedSubItems => selectedSubItems.filter(elem => elem?.slug !== slug))
    //   return
    // }

    else {
      setSelectedSubItems(
        selectedSubItems.filter(elem => elem?.slug !== slug)
      )
    }
  }

  //функція для скидання всих станів 
  function resetAll() {
    // console.log('resetAll')
    setActiveFilters([])
    setSelectedSubItems([])
    setVisibilityFilter(undefined)
    setDateFrom(null)
    setDateTo(null)
    setMakeRequest(true)
  }

  function findAllOwners(data) {
    let allOwnersFromData = [];

    const filteredRows = data['hydra:member'].filter(page =>
      page.language === null || page.language.id === 1
    );

    filteredRows
      // data['hydra:member']
      .forEach(elem => {
        if (elem.owners.length > 0) {
          allOwnersFromData.push(elem.owners)
        }
      })

    // console.log('allOwnersFromData', allOwnersFromData.flat())
    function uniqueById(arr) {
      return arr.filter((item, index, self) => {
        // console.log('elem', item)
        return item?.id && index === self.findIndex(t => t.id === item.id);
      });
    };

    return {
      flatOwners: uniqueById(allOwnersFromData.flat()),
    }
  }

  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            AxiosInstance.delete('/posts/' + row.id).then(()=> {
              getRowsTable(currentPage);
              getAllPostsWithoutPagination();
            }).catch(err => {
              console.log("delete err", err);
            });
            // const deleteMain = () => AxiosInstance.delete('/posts/' + row.id);
            // if (row.translations.length > 0) {
            //   const deletePromises = row.translations.map(translate =>
            //     AxiosInstance.delete('/posts/' + translate.id)
            //   );

            //   Promise.all(deletePromises)
            //     .then(() => deleteMain())
            //     .then(() => {
            //       getRowsTable(currentPage);
            //       getAllPostsWithoutPagination()
            //     })
            //     .catch(err => {
            //       console.log("delete translations or main err", err);
            //     });
            // } else {
            //   deleteMain().then(() => {
            //       getRowsTable(currentPage);
            //       getAllPostsWithoutPagination()
            //     })
            //     .catch(err => {
            //       console.log("delete main err", err);
            //     });
            // }
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  function Hidden(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите змінити пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            // змінити всі show у children translations якщо змінюєм батька
            axios.put(process.env.REACT_APP_SERVER_URL + '/api/posts/' + row.id, { show: row.show !== undefined ? !row.show : true }, header).then(() => {
              if (row.translations.length > 0) {
                const updatePromises = row.translations.map(translate =>
                  axios.put(process.env.REACT_APP_SERVER_URL + '/api/posts/' + translate.id, { show: row.show !== undefined ? !row.show : true }, header)
                );

                Promise.all(updatePromises)
                  .then(() => {
                    getRowsTable(currentPage);
                  })
                  .catch(err => {
                    console.log("update show translations err", err);
                  });
              } else {
                getRowsTable(currentPage);
              }
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const columns = [
    {
      field: 'id',
      sortable: false,
      disableColumnMenu: true,
      headerName: 'ID',
      width: 70
    },
    {
      field: 'name',
      headerName: 'Назва',
      width: 500,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {formatShortName(params.row.name)}
          </div>
        );
      }

    },
    // { field: 'content', headerName: 'Опис', width: 400,
    //   renderCell: (params)=>{
    //    return <div dangerouslySetInnerHTML={{__html: params.row.content}}></div>
    //   }},
    {
      field: 'dateEntered',
      headerName: 'Дата публікації',
      type: 'date',
      width: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{formatUTC(params.row.dateEntered)}</div>
      }
    },
    {
      field: 'dateModified',
      headerName: 'Дата модифікації',
      type: 'date',
      width: 160,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <div>{formatUTC(params.row.dateModified)}</div>
      }
    },
    {
      field: 'owner',
      headerName: 'Користувач/Автори',
      // width: 360,
      width: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params.row.owners?.length > 0
          ? <div>
            {params.row.owners.map(owner => {
              return <span key={owner?.id} className='category-span'>{`${owner.firstName || ''} ${owner.lastName || ''}`}</span>
            })}
          </div>
          : <div></div>
      }
    },

    {
      field: 'showStatus',
      headerName: 'Visibility',
      headerAlign: 'center',
      align: 'center',
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <Status type={params.row.show ? 'visible' : 'hidden'} />
      }
    },
    {
      field: "action",
      headerName: ''
      //  "Action"
      ,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      renderCell: (params) => {

        if (type != undefined && type != 'page')
          return <Link to={`/post/${type}/${params.row.id}`}>
            {/* <CButton color="dark" variant="outline" title="Редагувати"> */}
            {/* <CIcon icon={cilPen} customClassName="nav-icon" height={20} /> */}
            <img src="/edit.svg" alt="edit" />
            {/* </CButton> */}
          </Link>
        else
          return <Link to={'/post/update/' + params.row.id}>
            {/* <CButton color="dark" variant="outline" title="Редагувати"> */}
            {/* <CIcon icon={cilPen} customClassName="nav-icon" height={20} /> */}
            <img src="/edit.svg" alt="edit" />
            {/* </CButton> */}
          </Link>


      }
    },
    {
      field: "delete",
      headerName: ''
      //  "Видалити"
      ,
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      // renderCell: (params) => {
      //   return (
      //     <CButton color="danger" variant="outline" onClick={() => {
      //       Deleted(params.row)
      //     }
      //     }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
      //     </CButton>
      //   )
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }
    },
    {
      field: "show",
      headerName: ''
      // "Відображати"
      ,
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      disableColumnMenu: true,
      // renderCell: (params) => {
      //   return <CFormCheck id="formCheck" label="" disabled={!Permissions(user, 'Blog', 'HIDE_BLOG')} onChange={() => Hidden(params.row)} checked={params.row.show !== undefined ? params.row.show : false} />;
      // }
      renderCell: (params) => {
        return <button disabled={!Permissions(user, 'Blog', 'HIDE_BLOG')} className='transparent' onClick={() => Hidden(params.row)}>
          {params.row.show ? <img src="/show.svg" alt="show" /> : <img src="/hidden.svg" alt="hidden" />}
        </button>
      }

    },
  ];


  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4 mt-4">
          <CCardHeader className='items_card_header'>
            {/* <strong> */}
            Публікації
            {/* </strong> */}
          </CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper_with_filter'>
              {/* <p className="text-medium-emphasis small">
                <Link to="/post/create">Створити</Link>
              </p> */}
              <p className="text-medium-emphasis small"
                // style={{ order: '2' }}
                style={{ order: '3' }}
              >
                {
                  (type != undefined && type != 'page') ?
                    <Link to={`/post/${type}/create`} className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                      {/* Створити */}
                      Add
                    </CButton></Link>
                    :
                    <Link to="/post/create" className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                      {/* Створити */}
                      Add
                    </CButton></Link>
                }
              </p>
              <FilterDropdownBlog_main
                posts={posts}
                setPosts={setPosts}
                selectedSubItems={selectedSubItems}
                setSelectedSubItems={setSelectedSubItems}
                visibilityFilter={visibilityFilter}
                setVisibilityFilter={setVisibilityFilter}
                allOwners={allOwners}
                setAllOwners={setAllOwners}
                handleSubItem={handleSubItem}
                cleanListItem={cleanListItem}
                dateTo={dateTo}
                setDateTo={setDateTo}
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                makeRequest={makeRequest}
                setMakeRequest={setMakeRequest}
                resetAll={resetAll}
                handleActiveFilters={handleActiveFilters}
                activeFilters={activeFilters}
              />
              <CInputGroup
                // className="mb-3 item_add_input_wrapper"
                // style={{ border: '1px solid #ccc', height: '40px', width: '228px', borderRadius: "12px" }}
                className='mb-3 item_add_input_wrapper_round'
                style={{ order: '1' }}
              >
                <CInputGroupText style={{ backgroundColor: 'transparent', border: 'none', padding: 0, paddingLeft: '10px' }}>
                  {/* <CIcon icon={cilSearch} /> */}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                      stroke="#767781"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </CInputGroupText>
                <CFormInput
                  className="item_add_input_round"
                  type="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
              </CInputGroup>
            </div>


            {/* Блок додавання активних фільтрів */}
            <ActiveFilters
              activeFilters={activeFilters}
              dateFrom={dateFrom}
              dateTo={dateTo}
              setDateFrom={setDateFrom}
              setDateTo={setDateTo}
              setMakeRequest={setMakeRequest}
              cleanListItem={cleanListItem}
            />
            {/* Блок додавання активних фільтрів (верх)*/}

            <div style={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                // rowsPerPageOptions={[postPerPage]}
                rowsPerPageOptions={[pageSize]}
                // checkboxSelection
                paginationMode="server"
                onPageChange={handlePageChange}

                rowCount={rowCount}
                components={{ Pagination: CustomPagination }}
                headerHeight={44}
                getRowClassName={(params) =>
                  selectedIds.includes(params.row.id) ? 'active-row' : ''
                }

                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default Blog;
